import React from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { StubLoginToProceed } from 'components/StubLoginToProceed';
import ContinueWatchingIcon from 'components/Icons/continue-watching';
import { navigateToAuthPage } from 'actions/app';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const NotLoggedStub = () => {
  const dispatch = useDispatch();
  const onLoginEnter = () => {
    innerAnalyticsVolia.postEvent({
      eventGroup: 'dashboard: CONTINUE_WATCHING',
      eventName: 'click sign in',
    });
    dispatch(navigateToAuthPage());
  };

  return (
    <StubLoginToProceed onLoginEnter={onLoginEnter}>
      <ContinueWatchingIcon />
      <div>{i18n.t('continueWatching.loginToProceed')}</div>
    </StubLoginToProceed>
  );
};

export default NotLoggedStub;
